module.exports = ".prime-form {\n  margin-bottom: 30px;\n  width: 100%; }\n\n.single-datepicker-input-container input[type=\"text\"] {\n  width: 100%;\n  border: 1px solid #d6d6d6; }\n\n.has-error {\n  border: 1.5px solid #ff1744 !important;\n  height: 50px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/formulario/input-prime-datepicker/input-prime-datepicker.component.scss
// module id = ./src/app/components/formulario/input-prime-datepicker/input-prime-datepicker.component.scss
// module chunks = main